import ilSordoTheme from "./ilsordo";
import { createTheming } from '@callstack/react-theme-provider';
const { ThemeProvider, withTheme, useTheme } = createTheming(ilSordoTheme);
export { ThemeProvider, withTheme, useTheme };